/**
 * Утилиты для шаринга и экспорта данных
 */

// Отправка в Telegram через share API или ссылку
export const shareToTelegram = (text, url = null) => {
  const message = url ? `${text}\n\n${url}` : text;
  const telegramUrl = `https://t.me/share/url?url=${encodeURIComponent(message)}`;
  window.open(telegramUrl, '_blank');
};

// Отправка подписки в Telegram bot
export const sendToTelegramBot = (subscription) => {
  const botUrl = `https://t.me/vless_helperz_bot?start=sub_${encodeURIComponent(subscription)}`;
  window.open(botUrl, '_blank');
};

// Использование Web Share API (если доступно)
export const shareViaWebAPI = async (title, text, url = null) => {
  if (navigator.share) {
    try {
      await navigator.share({
        title,
        text,
        url: url || undefined
      });
      return true;
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error sharing:', error);
      }
      return false;
    }
  }
  return false;
};

// Сохранение подписки в файл конфигурации
export const saveSubscriptionToFile = (subscription, orderNumber) => {
  const content = subscription;
  const blob = new Blob([content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `vless-subscription-${orderNumber || Date.now()}.txt`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Сохранение конфигурации для конкретного VPN клиента
export const saveConfigForClient = (subscription, clientName, orderNumber) => {
  const configs = {
    v2ray: {
      extension: 'json',
      content: JSON.stringify({
        log: { loglevel: 'warning' },
        inbounds: [{ port: 1080, protocol: 'socks', settings: { auth: 'noauth' } }],
        outbounds: [{ protocol: 'vless', settings: { vnext: [subscription] } }]
      }, null, 2)
    },
    clash: {
      extension: 'yaml',
      content: `proxies:\n  - name: "VLESS"\n    type: vless\n    server: ${subscription}`
    },
    shadowrocket: {
      extension: 'txt',
      content: subscription
    }
  };

  const config = configs[clientName] || configs.shadowrocket;
  
  const blob = new Blob([config.content], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = `${clientName}-config-${orderNumber || Date.now()}.${config.extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

// Копирование с уведомлением
export const copyToClipboardWithFeedback = async (text, onSuccess, onError) => {
  try {
    await navigator.clipboard.writeText(text);
    if (onSuccess) onSuccess();
    return true;
  } catch (err) {
    console.error('Failed to copy:', err);
    if (onError) onError(err);
    return false;
  }
};

// Проверка поддержки Web Share API
export const isWebShareSupported = () => {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
};

// Создание календарного события (напоминание о подписке)
export const createCalendarReminder = (title, date, notes) => {
  const startDate = new Date(date);
  const endDate = new Date(date);
  endDate.setHours(endDate.getHours() + 1);

  const formatDate = (d) => {
    return d.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
  };

  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'BEGIN:VEVENT',
    `DTSTART:${formatDate(startDate)}`,
    `DTEND:${formatDate(endDate)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${notes}`,
    'BEGIN:VALARM',
    'TRIGGER:-PT24H',
    'ACTION:DISPLAY',
    'DESCRIPTION:Напоминание',
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\n');

  const blob = new Blob([icsContent], { type: 'text/calendar' });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement('a');
  link.href = url;
  link.download = 'vpn-subscription-reminder.ics';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};











